import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2InfoIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.5 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.5",
    children: [/*#__PURE__*/jsx("path", {
      d: "M28.25 32.75h-1.5a3 3 0 01-3-3v-7.5a1.5 1.5 0 00-1.5-1.5h-1.5M23 13.25a.75.75 0 10.75.75.75.75 0 00-.75-.75z"
    }), /*#__PURE__*/jsx("circle", {
      cx: "23.75",
      cy: "23.75",
      r: "22"
    })]
  });
};

export { PM2InfoIcon };
//# sourceMappingURL=info.js.map
